import classNames from 'classnames';
import { FC, memo } from 'react';
import Example from '../Example';

interface iColorProps {
  color: string;
  name: string;
  active?: boolean;
  onSelect: (color: string) => void;
  example: string
}

const Color: FC<iColorProps> = memo(({ color, active, onSelect, name , example}) => {
  const _handleSelect = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    onSelect(color);
  };
  return (
    <div className={classNames('color-wrapper', active && 'active')} onMouseDown={_handleSelect}>
      <div className='color' style={{ backgroundColor: color }} />
      <span className='name'>{name}</span>
      <Example content={example} />
    </div>
  );
});

export default Color;
